var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.33333C0 1.04271 1.02143 0 2.28571 0H29.7143C30.9786 0 32 1.04271 32 2.33333C32 3.62396 30.9786 4.66667 29.7143 4.66667H2.28571C1.02143 4.66667 0 3.62396 0 2.33333ZM0 14C0 12.7094 1.02143 11.6667 2.28571 11.6667H29.7143C30.9786 11.6667 32 12.7094 32 14C32 15.2906 30.9786 16.3333 29.7143 16.3333H2.28571C1.02143 16.3333 0 15.2906 0 14ZM32 25.6667C32 26.9573 30.9786 28 29.7143 28H2.28571C1.02143 28 0 26.9573 0 25.6667C0 24.376 1.02143 23.3333 2.28571 23.3333H29.7143C30.9786 23.3333 32 24.376 32 25.6667Z",
    fill: "#7C6CC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.8bd089d549907f217229834cddfd03de.svg";
export { ForwardRef as ReactComponent };